const logoutUser = () => {
  localStorage.removeItem('authToken');
  localStorage.removeItem('aipe_user');
  window.location.href = '/user/login';
};

export default logoutUser;
